__turbopack_context__.v({
  "promo": "PromoBanner-module-scss-module__Hvx4lW__promo",
  "promo__action": "PromoBanner-module-scss-module__Hvx4lW__promo__action",
  "promo__body": "PromoBanner-module-scss-module__Hvx4lW__promo__body",
  "promo__copy": "PromoBanner-module-scss-module__Hvx4lW__promo__copy",
  "promo__eyebrow": "PromoBanner-module-scss-module__Hvx4lW__promo__eyebrow",
  "promo__footnote": "PromoBanner-module-scss-module__Hvx4lW__promo__footnote",
  "promo__headline": "PromoBanner-module-scss-module__Hvx4lW__promo__headline",
  "promo__image": "PromoBanner-module-scss-module__Hvx4lW__promo__image",
  "promo__media": "PromoBanner-module-scss-module__Hvx4lW__promo__media",
});
